import Vue from "vue";
import JsonCSV from "vue-json-csv";

Vue.component("downloadCsv", JsonCSV);

export const generateCSV = ({ title, data }) => {
  let csvContent = "data:text/csv;charset=utf-8,";
  csvContent += [
    Object.keys(data[0]).join(";"),
    ...data.map(item => Object.values(item).join(";"))
  ]
    .join("\n")
    .replace(/(^\[)|(\]$)/gm, "");

  const csvData = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", csvData);
  link.setAttribute("download", `${title}.csv`);
  link.click();
};
